import Extend from 'flarum/common/extenders';
import FormIndexPage from './pages/FormIndexPage';
import FormShowPage from './pages/FormShowPage';
import FormEditPage from './pages/FormEditPage';
import SubmissionIndexPage from './pages/SubmissionIndexPage';
import SubmissionPage from './pages/SubmissionPage';
import DebugPage from './pages/DebugPage';
import ProfilePage from './pages/ProfilePage';

const extend = [
    new Extend.Routes()
        .add('formulaireFormIndex', '/formulaire', FormIndexPage)
        .add('formulaireFormIndexDiscussion', '/formulaire/discussion', FormIndexPage)
        .add('formulaireFormIndexUser', '/formulaire/user', FormIndexPage)
        .add('formulaireFormShow', '/forms/:id', FormShowPage)
        .add('formulaireFormEdit', '/formulaire/:id', FormEditPage)
        .add('formulaireSubmissionIndex', '/formulaire/:id/submissions', SubmissionIndexPage)
        .add('formulaireSubmission', '/submissions/:id', SubmissionPage)
        .add('formulaireDebug', '/formulaire-debug', DebugPage)
        .add('formulaireProfile', '/u/:username/forms/:form', ProfilePage),
];

export default extend;
